<template>
    <b-modal
        class="apprentice-default-modal"
        id="edit-group-modal"
        v-model="modal"
        ref="edit-group-modal"
        :title="$t('group.internship.edit_data')"
        :ok-disabled="!group.name"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()">
        <div class="title">
            <b-form-group
                :label="$t('common.title')"
                label-for="group-edit-title-input">
                <b-form-input
                    id="group-edit-title-input"
                    v-model="group.name"
                    :placeholder="$t('common.title')"></b-form-input>
            </b-form-group>
        </div>

        <div
            class="course"
            v-if="!group.parent">
            <b-form-group
                :label="$t('group.internship.course')"
                label-for="group-edit-course-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="group-edit-course-select"
                    v-model="group.course_id">
                    <option
                        v-for="course in coursesIn"
                        :value="course.id">
                        {{ course.name }}
                    </option>
                </b-form-select>
            </b-form-group>
        </div>

        <div
            class="season"
            v-if="!group.parent_id">
            <b-form-group
                :label="$t('group.internship.school_year')"
                label-for="group-edit-season-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="group-edit-season-select"
                    v-model="group.season_id">
                    <option
                        v-for="season in seasonsIn"
                        :value="season.id">
                        {{ season.season }}
                    </option>
                </b-form-select>
            </b-form-group>
        </div>

        <div class="start-date">
            <b-form-group
                :label="$t('group.internship.start_date')"
                label-for="group-edit-startdate-picker">
                <b-form-datepicker
                    class="apprentice-date-picker btn-date-group"
                    id="group-edit-startdate-picker"
                    v-model="start[0]"
                    start-weekday="1"
                    now-button
                    reset-button
                    right
                    locale="nl"
                    :aria-controls="$t('group.internship.choose_date')"
                    label-reset-button="reset"
                    today-variant="primary"
                    nav-button-variant="primary"
                    :label-no-date-selected="$t('group.internship.no_date_selected')"
                    menu-class="datedropdown"
                    @input="updateDate($event, 'start')"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
                </b-form-datepicker>
            </b-form-group>

            <b-form-group :label="$t('group.internship.start_time')">
                {{ $t('group.internship.from_this_date_the_project_will_be_shown_to_students') }}
                <design-2021-apprentice-timepicker-component
                    v-model="start[1]"></design-2021-apprentice-timepicker-component>
            </b-form-group>
        </div>

        <div class="end-date">
            <b-form-group
                :label="$t('group.internship.end_date')"
                label-for="group-edit-enddate-picker">
                <b-form-datepicker
                    class="apprentice-date-picker btn-date-group"
                    id="group-edit-enddate-picker"
                    v-model="group.end"
                    start-weekday="1"
                    now-button
                    reset-button
                    right
                    locale="nl"
                    today-variant="primary"
                    nav-button-variant="primary"
                    :aria-controls="$t('group.internship.choose_date')"
                    label-reset-button="reset"
                    :label-no-date-selected="$t('group.internship.no_date_selected')"
                    menu-class="datedropdown"
                    @input="updateDate($event, 'end')"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
                </b-form-datepicker>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-edit-group-modal-component',
    props: ['groupIn', 'coursesIn', 'seasonsIn'],
    data() {
        return {
            group: this.groupIn,
            start: [],
            end: null,
            modal: false,
        };
    },
    mounted() {
        this.start = this.group.start.split(' ');
    },
    methods: {
        updateDate(event, type) {
            if (type === 'start') {
                this.startDate = event;
            } else {
                this.end = event;
            }
        },
        updateTime(event) {
            this.startTime = event;
        },
        onOk() {
            this.alert.saving();
            if (this.end === null) {
                this.end = this.group.end;
            }
            let startDateTime = this.start[0];
            if (this.start[1]) {
                startDateTime = this.start[0] + ' ' + this.start[1];
            }

            const data = {
                title: this.group.name,
                season_id: this.group.season_id,
                course_id: this.group.course_id,
                start_date: startDateTime,
                end_date: this.end,
            };

            this.axios.post(this.routes.baseUrl() + '/group/' + this.group.id, data).then(
                (response) => {
                    this.title = response.data.name;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
